import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'talk-to-your-data-message-input',
  templateUrl: './message-input.component.html',
  styleUrls: ['./message-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageInputComponent implements OnChanges, AfterViewInit {
  @Input() disabled = false;
  @Input() focusTrigger = 0;
  @Output() readonly messageSubmitted = new EventEmitter<string>();
  @Output() readonly stopRequested = new EventEmitter<void>();
  @ViewChild('messageInput') messageInput: ElementRef<HTMLInputElement> | undefined;

  ngAfterViewInit(): void {
    this.focusInput();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['focusTrigger'] && !changes['focusTrigger'].firstChange) {
      this.focusInput();
    }
  }

  private focusInput(): void {
    queueMicrotask(() => {
      this.messageInput?.nativeElement.focus();
    });
  }

  onSendMessage(): void {
    if (this.disabled) {
      return;
    }

    const inputElement = this.messageInput?.nativeElement;
    if (!inputElement) {
      return;
    }

    const trimmedText = inputElement.value.trim();
    if (!trimmedText) {
      return;
    }

    this.messageSubmitted.emit(trimmedText);
    inputElement.value = '';
    inputElement.focus();
  }
  onStop(): void {
    this.stopRequested.emit();
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSendMessage();
    }
  }
}
